import { useAtomValue } from "jotai";
import { type FC, useMemo } from "react";
import { useCustomTemplates } from "../../pages/create-content/use-custom-templates";
import { brandingAtom, brandingImageTypeAtom } from "../brand-kit/store";
import type { BrandKitManager } from "../brand-kit/types";
import { useMultiformat } from "../multiformat/hooks/use-multi-format";
import { CustomStyleSelect } from "./custom-style-select";
import { ImageShapeSelect } from "./image-shape-select";
import { VisualStyleSelect } from "./visual-style-select";

export const ImageStyle: FC<{
  visualStyleSelector?: boolean;
  imageTypeSelector?: boolean;
  manager: BrandKitManager;
}> = ({ visualStyleSelector = false, imageTypeSelector = false, manager }) => {
  const { data: multiformat } = useMultiformat();
  const customTemplatesLoader = useCustomTemplates(multiformat);
  const { branding_type: brandStyle } = useAtomValue(brandingAtom);
  const imageType = useAtomValue(brandingImageTypeAtom);

  const hasCustomTemplates = useMemo(() => {
    if (customTemplatesLoader.loading) return false;

    const squares = customTemplatesLoader.data?.["Square Comms"] ?? [];
    const banners = customTemplatesLoader.data?.["Landscape Comms"] ?? [];

    return squares.length > 0 || banners.length > 0;
  }, [customTemplatesLoader]);

  if (customTemplatesLoader.loading) return null;

  return (
    <>
      {imageTypeSelector && visualStyleSelector && hasCustomTemplates ? (
        <CustomStyleSelect
          manager={manager}
          data-testid="custom-style-select"
          customTemplates={customTemplatesLoader.data!}
        />
      ) : (
        imageTypeSelector &&
        visualStyleSelector && (
          <>
            <VisualStyleSelect
              onChange={manager.style.setSelected}
              data-testid="visual-style-select"
              brandStyle={brandStyle}
            />
            <ImageShapeSelect
              onChange={manager.imageType.setSelected}
              data-testid="image-type-select"
              imageType={imageType}
            />
          </>
        )
      )}
      {visualStyleSelector && !imageTypeSelector && (
        <VisualStyleSelect
          onChange={manager.style.setSelected}
          data-testid="visual-style-select"
          brandStyle={brandStyle}
        />
      )}
    </>
  );
};
